import LaporanRekapitulasiHasilProduksiApi from "./LaporanRekapitulasiHasilProduksiApi";

export default LaporanRekapitulasiHasilProduksiApi;
